import React from 'react'
import {RuntimeContext} from '../../../commons/components/runtime-context/runtime-context'
import {MemberAppProps} from '../interface'
import {MemberPageState} from '../Widget/types/state'

export function useMembersPageState<T>(selector: (state: MemberPageState) => T): T {
  return selector(React.useContext<MemberAppProps>(RuntimeContext).state)
}
